<template>
  <div>
    <!-- Pay -->
    <a-modal v-model="visible" title="Order details" onOk="handleOk"
      :width="this.settings['isMobileView'] ? 360 : this.settings['isTabletView'] ? 560 : 1080"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="downloadBill">Download Bill</a-button>
      </template>
      <a-spin :spinning="spinning">
      <div class="row align-items-center">
        <div class="col-md-12">
          <h5 class="font-weight-bold mb-0">{{productOrder.student.first_name}} {{productOrder.student.last_name}}</h5>
          <p>
            <span class="pr-2">Student ID:</span> <span class="font-weight-bold px-2">{{productOrder.student.student_code}}</span>|
            <span class="px-2">Class:</span> <span class="font-weight-bold px-2">{{productOrder.student.enrollment[0].school_class.name}}</span>|
            <span class="px-2">Section:</span> <span class="font-weight-bold px-2">{{productOrder.student.enrollment[0].section.name}}</span>|
            <span class="px-2">Roll No:</span> <span class="font-weight-bold px-2">{{productOrder.student.enrollment[0].roll_no}}</span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <p><span class="pr-2">Order no.:</span> <span class="font-weight-bold px-2">{{productOrder.order_no}}</span></p>
        </div>
        <div class="col-md-6 text-right">
          <p><span class="pr-2">Date:</span> <span class="font-weight-bold px-2">{{moment(productOrder.order_date).format('DD-MMM-YYYY h:mm A')}}</span></p>
        </div>
      </div>
      <hr class="m-0">
        <table class="table table-borderless">
          <thead class="bg-light">
          <tr>
            <th width="50px">No.</th>
            <th width="100px">Code</th>
            <th width="300px">Items</th>
            <th width="70px" class="text-right">Rate(Rs)</th>
            <th width="70px" class="text-right">Quantity</th>
            <th width="70px" class="text-right">Total</th>
<!--            <th class="text-right">Actions</th>-->
          </tr>
          </thead>
          <tbody>
            <tr v-for="(orderItem, index) in productOrder.order_items"
                :key="orderItem.id">
              <td>{{index + 1}}</td>
              <td>{{ orderItem.product.code }}</td>
              <td>{{ orderItem.product.name }}</td>
              <td class="text-right">{{ orderItem.unit_price }}</td>
              <td class="text-right">{{ orderItem.quantity }}</td>
              <td class="text-right">{{ orderItem.total_amount }}</td>
            </tr>
            <tr class="bg-light">
              <td colspan="5" class="text-right font-weight-bold">Total(Rs.)</td>
              <td class="text-right font-weight-bold">{{ productOrder.total_amount }}</td>
            </tr>
          </tbody>
        </table>
        <div>
          <p style="margin-bottom: 2px; width: 100%">
            <span class="pr-2"><b>Paid by: </b>{{productOrder.paid_by}}</span>
            <span class="pr-2 float-right"><b>Created by: </b> {{productOrder.created_by.first_name}} {{productOrder.created_by.last_name}}</span>
          </p>
          <p style="margin-bottom: 2px;"><span class="pr-2"><b>Remark: </b>{{productOrder.remark}}</span></p>
        </div>
      </a-spin>
<!--      <a-spin :spinning="spinning">
        <div v-if="student && studentFeeData">
          <pay-history :studentFeeData="studentFeeData" :student="student" :schoolData="schoolData" id="feePaymentMistory"/>
        </div>
      </a-spin>-->
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { downloadBill } from '../../common'
export default {
  name: 'OrderDetails',
  components: {
  },
  props: {
    isPublic: {
      default: false,
    },
    schoolData: {
      default: null,
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY',
      productOrder: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openViewOrderDetailsModal', this.showModal)
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    moment,
    showModal: function(productOrder) {
      console.log('inside openViewOrderDetailsModal')
      console.log('productOrder:: ', productOrder)
      this.visible = true
      this.spinning = true
      this.getOrderDetails(productOrder)
    },
    getOrderDetails: function (productOrder) {
      this.$http
        .get('/api/inventory/order/single/' + productOrder.id)
        .then(({ data }) => {
          this.spinning = false
          this.productOrder = data.data
        })
        .catch(error => {
          this.$nprogress.done()
          this.$neoNotify.error(error)
        })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    downloadBill() {
      downloadBill(
        this.$http,
        this.productOrder.id,
        this.productOrder.student.student_code,
        this.productOrder.order_no
      )
    },
    print () {
      // Pass the element id here
      this.$htmlToPaper('feePaymentMistory')
    },
  },
}
</script>
